import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

interface ProtectedRouteProps {
  element: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element}) => {
    const { user, loading } = useAuth();

    if (loading) {
      return <> </>;
    }
  
    return user ? element : <Navigate to="/login" />;
};

export default ProtectedRoute;